/*eslint-disable*/
import React, { Component } from 'react'
import AddTitleBar from '../../components/titleBar/add_titleBar'
import InsertDocument from '../../components/documentComponent/insertDocument'
import { connect } from 'react-redux'

import { getVehicleNo } from '../../redux/actions/inputApiActions'
import { getDocumentList } from '../../redux/actions/documentActions'

class AddDocument extends Component {

    componentDidMount(){
        this.props.getVehicleNo();
        this.props.getDocumentList();
    }

    render() {
        const { vehicleData } = this.props

        return (
            <React.Fragment>
                <AddTitleBar Title="New Document" LinkName="/document" />
                <InsertDocument vehicleData={vehicleData} />
            </React.Fragment>
        )
    }
}

const mapStatetoProps = (state) => ({
    vehicleData: state.getVehicleNo.vehicleNo.data,
})

export default connect(mapStatetoProps, { getVehicleNo, getDocumentList })(AddDocument)